import { useState,useRef } from 'react';
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUp } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from 'react-i18next';

const Body = ({sectionFacilitatorRef,hours,udateCompindex}) => {
    const { t, i18n } = useTranslation();
 const [active, setActive] = useState(false);
 const [activeCalss, setActiveClass] = useState("container");
console.log(hours);
 const handelcollapse= () => {
    if(!active){
        setActive(true); 
        setActiveClass('container remove-collapsed');
    }else{
        setActive(false); 
        setActiveClass('container');
    }
 }

   const show_facilator = (item,description) => {
    let max = 100;
    let min = 1;
    console.log(description);
    udateCompindex(Math.floor(Math.random() * (max - min + 1)) + min);
    sessionStorage.setItem('fac_item_data', JSON.stringify(item));
    sessionStorage.setItem('fac_item_desctiption', JSON.stringify(description));
     sessionStorage.setItem('fac_item_desctiption_info2', JSON.stringify(item.info2));
  }

  return (
     <section className="all-facilator-banner" ref={sectionFacilitatorRef}>
    <img src="img/all-facilator-guide.jpg" alt=""/>
    <div className={activeCalss}>
        <div className="guide-toggle">
            <div className="accordion" id="accordionExample">
                <div className="accordion-item">
                  <h3 className="accordion-header">
                    <button className="accordion-button collapsed" onClick={handelcollapse} type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                    {t("All_Facilitators_Guides")}
                    </button>
                  </h3>
                  <div id="collapseOne" className="accordion-collapse collapse show" data-bs-parent="#accordionExample">
                    <div className="accordion-body">
                        <div className="guide-wrapper">
                        {hours.map((item, index) => (
                            <div key={index} className="guide-items d-flex">
                                <div className="session-hour">
                                    <h3>{item.title}</h3>
                                </div>
                                <div className="session-guide-content">
                                {item.description.map((description, index) => (
                                    <div key={index} className="session-info d-flex justify-content-between">
                                        <div className="">
                                            <li><span>{description.title}</span></li>
                                        </div>
                                        
                                        {index == 1 ? <div className="session-btn"><Link href="#" onClick={() => show_facilator(item,description)} data-bs-toggle="modal" data-bs-target="#pdfModalall">{t("open")} <span><FontAwesomeIcon icon={faArrowUp} /></span></Link> </div>: ''}
                                        
                                    </div>
                                ))}
                                </div>  
                            </div>
                        ))}
                           
                        </div>
                    </div>
                  </div>
                </div>
            </div>
        </div>
    </div>
</section>
  );
};

export default Body;